import registerSW from './registerSW';

export default function initServiceWorker(
  url: string,
  options: {
    /** current location origin */
    origin: string;
    onError: (error: Error) => void;
  },
) {
  const swUrl = new URL(url);

  if (swUrl.origin === options.origin) {
    registerSW(swUrl.href, { onError: options.onError });
  } else {
    // service worker won't work if swUrl.origin is on a different origin
    options.onError(
      new Error(`
        The origin of the provided scriptURL ('${swUrl.origin}')
        does not match the current origin ('${options.origin}').
      `),
    );
  }
}
